const getLoggedUser = state => state?.platform?.user;
const getUserData = state => state?.platform?.user?.userData;
const getError = state => state?.platform?.user?.error;
const getNewPasswordError = state => state?.platform?.user?.error?.find?.(error => error?.context === 'newPassword');

export { getLoggedUser, getUserData, getError, getNewPasswordError };
